export const B8Type = {
  PRIOR: 'PRIOR',
  MCE_1ST_YEAR: 'MCE_1ST_YEAR',
  MCE_3RD_YEAR: 'MCE_3RD_YEAR',

  values: () => {
    return ['PRIOR', 'MCE_1ST_YEAR', 'MCE_3RD_YEAR'];
  },
};
